import { render, staticRenderFns } from "./ChooseGvd.modal.vue?vue&type=template&id=31a4172d"
import script from "./ChooseGvd.modal.vue?vue&type=script&lang=ts"
export * from "./ChooseGvd.modal.vue?vue&type=script&lang=ts"
import style0 from "./ChooseGvd.modal.vue?vue&type=style&index=0&id=31a4172d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports